import { DynamicFormV2Palette } from "@mui/material";

export type FormZeffyLoaderComponentTokenType = {
  color: string;
};

export const assignZeffyLoaderComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    color: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.reverse,
  } as FormZeffyLoaderComponentTokenType;
};
